import React, { useEffect, useState} from 'react'
import { Page, Text, View, Document, StyleSheet, Image, Font} from '@react-pdf/renderer'
import AuthService from "../../api/ApiRest";
import Fondo from "../../assets/diploma_cerrado_fondo.png"
import Logo_cfc from "../../assets/logo_ctm_2.png"
import Logo_cfc_2 from "../../assets/CFC-UNAP-PLOMO.png"
import Logo_unap from "../../assets/unap_new.jpg"
import firma_director from "../../assets/firma_director.png"
import firma_psicologo from "../../assets/firma_psicologo2.png"
import firma_blanco from "../../assets/firma_blanco.png"
import firma_norman from "../../assets/firma_norman.png"
import OpenSans from "../../assets/fonts/OpenSans-Bold.ttf"
import Montserrat from "../../assets/fonts/Montserrat-Regular.ttf"
import MontserratM from "../../assets/fonts/Montserrat-Medium.ttf"
import MontserratB from "../../assets/fonts/Montserrat-Bold.ttf"
import Cooper from "../../assets/fonts/COOPBL.TTF"
import Aileron from "../../assets/fonts/Aileron-Bold.ttf"
import {format, parseISO } from 'date-fns';
import {es} from 'date-fns/locale';
import QRCodeImage from './QrCerrado';



const DiplomaCerrado2025 = ({datos}) => {
    Font.register({
        family: 'OpenSans',
        src: OpenSans ,
      });
    Font.register({
        family: 'Montserrat',
        src: Montserrat ,
      });
    Font.register({
    family: 'MontserratM',
    src: MontserratM ,
    });
    Font.register({
        family: 'Cooper',
        src: Cooper ,
      });
    Font.register({
    family: 'Aileron',
    src: Aileron ,
    });
    Font.register({
        family: 'MontserratB',
        src: MontserratB ,
        });
    const [participantes,setParticipantes]=useState([]);
    const [actividad,setActividad]=useState([]);
    const [director,setDirector]=useState([]);
    const [directorS,setDirectorS]=useState([]);
    const [encargado,setEncargado]=useState([]);
    useEffect(()=>{
        
        const participantesData=async()=>{
            const response= await AuthService.getParticipantes(datos.id);
            setParticipantes(response.data.body)
        }
        participantesData();
        const actividadData=async()=>{
            const response= await AuthService.getActividad(datos.id);
            setActividad(response.data.body[0])
        }
        actividadData();
        
        const firmaData=async()=>{
            const response= await AuthService.getFirmas();
            for (let index = 0; index < response.data.body.length; index++) {
                if(response.data.body[index].cargo==='D'){
                    setDirector(response.data.body[index])
                }
                if(response.data.body[index].cargo==='S'){
                    setDirectorS(response.data.body[index])
                }
                if(response.data.body[index].cargo==='E'){
                    setEncargado(response.data.body[index])
                }
            }
        }
        firmaData();
    },[])

        
    const capitalize=(str)=>{
        return str.charAt(0).toUpperCase()+str.slice(1);
    }
    function cambiarFormatoFecha(fecha,tipo){
        const fechaISO=parseISO(fecha);
        let fechaFormateada='';
        if(tipo==='dd'){
            fechaFormateada=format(fechaISO,'dd');
        }
        if(tipo==='MM'){
            fechaFormateada=capitalize(format(fechaISO,'MMMM',{locale:es}));
        }
        if(tipo==='yyyy'){
            fechaFormateada=format(fechaISO,'yyyy');
        }
        if(tipo==='dd-MM-yyyy'){
            fechaFormateada=format(fechaISO,'dd-MM-yyyy');
        }
        return fechaFormateada;
    }
    const [qrImage, setQrImage] = useState(null);

    const handleImageGenerated = (imageDataUrl) => {
        setQrImage(imageDataUrl);
    };
    const obtenerMesYAnioActual = () => {
        const fechaActual = new Date();
        const mes = fechaActual.getMonth(); // Número del mes (0 - 11)
        const anio = fechaActual.getFullYear(); // Año de cuatro dígitos
        
        // Array de nombres de meses
        const nombresMeses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
        const nombreMes = nombresMeses[mes]; // Obtener el nombre del mes
        
        return `${nombreMes} de ${anio}`; // Retornar el mes y el año formateados
    };
    const obtenerTextoFecha = (fechaInicio, fechaFin) => {
        if (!fechaInicio || !fechaFin) return '';
      
        // Crear fechas asegurando que se interpretan correctamente en la zona horaria local
        const fechaInicioObj = new Date(`${fechaInicio}T00:00:00`);
        const fechaFinObj = new Date(`${fechaFin}T00:00:00`);
      
        // Extraer mes y año correctamente
        const mesInicio = fechaInicioObj.toLocaleDateString('es-ES', { month: 'long' });
        const mesFin = fechaFinObj.toLocaleDateString('es-ES', { month: 'long' });
      
        const añoInicio = fechaInicioObj.getFullYear();
        const añoFin = fechaFinObj.getFullYear();
      
        if (mesInicio === mesFin && añoInicio === añoFin) {
          return `EN EL MES DE ${mesInicio} DE ${añoInicio}`;
        } else if (añoInicio === añoFin) {
          return `ENTRE EL MES DE ${mesInicio} Y ${mesFin} DE ${añoInicio}`;
        } else {
          return `ENTRE EL MES DE ${mesInicio} DE ${añoInicio} A ${mesFin} DE ${añoFin}`;
        }
      };      
    return (
        <>
        <Document>
        {participantes.length>0?(
        participantes.filter(alumno => alumno.estado_participante === 2).length > 0 ? (
        participantes
        .filter(alumno => alumno.estado_participante === 2)
        .map(alumno=>(
            <Page  key={"participanteActividad"+alumno.id} size="LETTER" orientation="landscape" style={styles.page}>
                <View style={styles.header} fixed>
                    <Image
                        src={Fondo}
                        style={styles.fondo}
                    />
                </View>
                <View style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: 5,
                    }}
                    >
                    {/* Espacio vacío (izquierda) */}
                    <View style={{ width: 40 }}/>
                    {/* ancho similar al logo */}
                    {/* Texto centrado */}
                    <View  style={[styles.subTitulo,{ flex: 1, alignItems: 'center',letterSpacing: 2,}]}>
                        <Text>EL CENTRO TECNOLÓGICO MINERO S.A.</Text>
                        <Text>OTORGA EL PRESENTE DIPLOMA A:</Text>
                    </View>
                    {/* Logo derecho */}
                    <Image src={Logo_cfc} style={{ width: 90, height: 90 }} />
                </View>
                

                <View  style={styles.alumno}>
                    <Text>{alumno.nombres} {alumno.primer_apellido} {alumno.segundo_apellido}</Text>
                    <Text>RUT {alumno.run?alumno.run.toLocaleString('es-ES'):null}{alumno.extranjero==='N' ?'-'+alumno.dv:null}</Text>
                </View>
                <View  style={[styles.parrafo,{textAlign:'center',fontSize: 17,color: '#545454' } ]}>
                    <Text>POR SU PARTICIPACIÓN Y APROBACIÓN EN EL :</Text>
                    <Text style={styles.nombreCurso}>{actividad.nombre_generico}</Text>
                </View>
                {alumno.nota && (
                <>
                <View  style={[styles.subTitulo,{textAlign:'left',fontSize: 15 } ]}>
                    <Text>OBTENIENDO LA SIGUIENTE CALIFICACIÓN:</Text>
                </View>
                <View  style={[styles.parrafoBold,{marginTop:20} ]}>
                    <Text>EVALUACIÓN FINAL  : {parseInt(alumno.nota)}%</Text>
                </View>
                </>
                )}
                <View style={[styles.parrafo,{fontSize: 13,marginTop:20,color: '#545454' } ]}>
                    <Text>ESTE CURSO FUE DICTADO  <Text style={[styles.parrafoBold,{ fontSize: 13, color: '#000000' }]}>{obtenerTextoFecha(actividad.fecha_inicio_actividad, actividad.fecha_termino_actividad).toUpperCase()}</Text>, CON UNA DURACIÓN</Text>
                    <Text>DE <Text style={[styles.parrafoBold,{ fontSize: 13, color: '#000000' }]}>{actividad.horas} HORAS</Text>.</Text>
                </View>
                
                <View  style={styles.firmas}>
                    {/* Primera fila */}
                    <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 1 }}>
                        <Image src={firma_norman} style={{ width: 80, height: 80 }} />
                        <Text style={styles.nombreFirma}>{actividad.instructor_titular?.toUpperCase()}</Text>
                        <Text style={styles.cargoFirma}>INSTRUCTOR</Text>
                    </View>
                    <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 1 }}>
                        <Image src={firma_director} style={{ width: 80, height: 80 }} />
                        <Text style={styles.nombreFirma}>{directorS.habilitado==='S'?directorS.nombre?.toUpperCase()+' '+directorS.primer_apellido?.toUpperCase()+' '+directorS.segundo_apellido?.toUpperCase():director.nombre?.toUpperCase()+' '+director.primer_apellido?.toUpperCase()+' '+director.segundo_apellido?.toUpperCase()}</Text>
                        <Text style={styles.cargoFirma}>{directorS.habilitado==='S'?'Director(S)':director.cargo==='D'?'DIRECTOR':'Encargado de Proyecto'}</Text>
                    </View>
                </View>
                <View
                    style={{
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: 2,
                        paddingHorizontal: 10,
                    }}
                    fixed
                    >
                    <View style={[styles.piePagina,{ flexDirection: 'column',marginTop: 5, }]}>
                        <Text>FOLIO Nº{alumno.num_folio_diploma?alumno.num_folio_diploma:''}/2025</Text>
                        <Text>FECHA DE EMISIÓN: {actividad.fecha_actual}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                        <View>
                            <QRCodeImage datos={{url:`https://intranet.cfcunap.cl/diploma/${alumno.id}`}} />
                        </View>
                        <Image src={Logo_cfc_2} style={{ width: 65, height: 50 }} />
                    </View>
                </View>
            </Page>
         ))
         ):(
            <Page size="LETTER" orientation="landscape" style={styles.page}>
            <View
              style={{
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
              }}
            ><Text>No existen participantes egresados.</Text></View>
          </Page>
          )
        ):null}
        </Document>
    </>
    )
}
// Create styles
const styles = StyleSheet.create({
    page: {
        paddingBottom: 20,
        paddingHorizontal: 85,
    },
    fondo:{
        width:"790px",
        height:"650px",
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    titulo:{
        paddingTop: 50,
        paddingBottom: 40,
        fontFamily: 'OpenSans',
        fontSize: 36,
        textAlign: 'center',
        color:'#253460',
    },
    subTitulo:{
        fontFamily: 'MontserratB',
        fontSize: 16,
        textAlign: 'center',
        color: '#545454',
    },
    alumno:{
        paddingTop: 5,
        paddingBottom: 10,
        fontFamily: 'OpenSans',
        fontWeight: 'bold',
        fontSize: 27,
        textAlign: 'center'
    },
    parrafo:{
        fontFamily: 'Montserrat',
        fontSize: 15,
    },
    parrafoBold:{
        fontFamily: 'MontserratB',
        fontSize: 17,
    },
    nombreCurso:{
        fontFamily: 'OpenSans',
        fontWeight: 'bold',
        fontSize: 24,
        textAlign: 'center',
        marginBottom: 25
    },
    fecha:{
        paddingTop: 25,
        fontFamily: 'Montserrat',
        fontSize: 16,
        textAlign: 'justify'
    },
    firmas:{
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
    },
    nombreFirma:{
        fontFamily: 'Aileron',
        fontSize: 15,
    },
    cargoFirma:{
        fontFamily: 'Montserrat',
        fontSize: 14,
    },
    header: {
        position: 'absolute',
        marginBottom: 20,
      },
    folio: {
        marginTop:35,
        fontSize: 12,
        color: 'grey',
      },
      piePagina: {
        fontSize: 12,
        textAlign: 'left',
        color: 'grey',
      },
  });

export default DiplomaCerrado2025
